import React, { useCallback } from "react";
import { socket } from "../../lib/socketio";
import { GroupTemplate } from "../Definitions/cl";
import { Grid } from "semantic-ui-react";
import ClearOverride from "../Macros/ClearOverride";
import SeqMacro from "../Macros/SeqMacro";
import Footer from "./Footer";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setCurrentPLC, setUserArray } from "../../actions/headerActions";
import { setUser } from "../../actions/navActions";
import RequestAccessModal from "../RequestAccess/RequestAccessModal";
import { SEQUENCE_OVERRIDES, isAuthorized } from "../../lib/authorization";

const SeqOverride_PSM2 = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [isCopied, setIsCopied] = React.useState(false);
  const location = useLocation();
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const [pop, setPop] = React.useState(false);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    if (tags.length === 0) {
      socket.emit("get tag names", [{ display_id: 249 }, { display_id: 128 }]);
      socket.on("receive tag names", (data) => {
        settags(data.tags_data);
        setIsCopied(false);
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);

  const FooterTags = tags.flatMap((t) => (t.display_id === 128 ? [t] : []));

  const GenTags = tags.flatMap((t) =>
    // t.page_name === 'Sequence Overrides' ? [t] : []);
    t.display_id === 249 ? [t] : [],
  );

  const display = GenTags.map((t) => t.page_name);

  const SeqTags = GroupTemplate(GenTags, "tag_display_subgroup");

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  const columns = [];
  const length = SeqTags[0].length;
  const rows = Math.round(length / 4);
  let i = 0;
  while (i < length) {
    columns.push(SeqTags[0].slice(i, i + rows));
    i += rows;
  }

  const parentcallback = useCallback((flag) => {
    if (flag === true) {
      settags([]);
      // setIsCopied(false);
    }
  }, []);

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <h1 style={styles.header}>{display[0]}</h1>
      <div style={styles.toggle}>
        {(electronApp || isAuthorized(user.hmi_role, SEQUENCE_OVERRIDES)) && (
          <ClearOverride
            key={ids}
            option={2}
            channel={"Clear All PSM2 Sequence Overrides"}
            title={"Clear All PSM2 Sequence Overrides"}
            parentCallback={parentcallback}
          />
        )}
      </div>
      <Grid inverted divided centered columns="equal" style={styles.grid}>
        {columns.map((c, i) => (
          <SeqMacro
            key={i}
            index={i}
            column={c}
            data={data}
            isCopied={isCopied}
            setIsCopied={setIsCopied}
          />
        ))}
      </Grid>
      <Footer tags={FooterTags} data={data} />
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  header: {
    marginBottom: "10px",
  },
  toggle: {
    textAlign: "center",
    marginBottom: "30px",
  },
  grid: {
    marginBottom: "10px",
  },
};

export default SeqOverride_PSM2;
